import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getCommonTextFilterParams,
  getSetFilterParams,
  getSetDatefilterParams,
} from '../../utils/agGridFilters';
import DeleteConfirmationModal from '../../shared/modal/deleteConfirmation';
import { DateFormatter } from '../../shared/controls/formatters';

const OptionButton = ({
  handleClickOpenEditForm,
  paramsValue,
  handleOpenViewForm,
  rowData,
  handleClickDelete,
}) => {
  const [showConfirmation, setShowConfirmation] = React.useState(false);

  const handleDeleteClick = () => {
    console.log('Delete clicked');
    setShowConfirmation(true);
  };

  const handleConfirmDelete = () => {
    handleClickDelete(paramsValue);
    setShowConfirmation(false);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="action-menu">
      <img
        src="/assets/images/edit.png"
        className="action-img1"
        onClick={() => handleClickOpenEditForm(paramsValue)}
        alt="Edit Price"
        title="Edit Price"
      ></img>

      <img
        src="/assets/images/view.png"
        className="action-img2"
        onClick={() => handleOpenViewForm(paramsValue)}
        alt="View Price"
        title="View Price"
      />

      <img
        src="/assets/images/trash.png"
        className="action-img2"
        onClick={handleDeleteClick}
        alt="Delete Price"
        title="Delete Price"
      ></img>
      <DeleteConfirmationModal
        show={showConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
        rowData={rowData}
      />
    </div>
  );
};

const usePriceColumnDefs = ({ priceSheetList, gridData, handleClickDelete, owner }) => {
  const navigate = useNavigate();
  const commonTextFilterParams = useMemo(() => getCommonTextFilterParams(), []);
  const dateFilterParams = useMemo(() => getSetDatefilterParams(), []);
  const filterParams = useMemo(() => getSetFilterParams, []);

  const handleClickOpenEditForm = (paramsValue) => {
    navigate('/products/priceSheet/editPriceSheet', {
      state: paramsValue,
    });
  };

  const handleOpenViewForm = (paramsValue) => {
    navigate(`/products/priceSheet/viewPriceSheet?id=${paramsValue.id}`, {
      state: paramsValue,
    });
  };

  const actionsColumn = useMemo(() => {
    return [
      {
        headerName: 'Actions',
        cellRenderer: (params) => {
          if (!params?.node || params.node.group) return null;
          const rowData = { ...params.data, rowIndex: params.rowIndex };
          return (
            <OptionButton
              rowData={rowData}
              handleClickOpenEditForm={() => handleClickOpenEditForm(rowData)}
              handleClickDelete={() => handleClickDelete(rowData)}
              handleOpenViewForm={() => handleOpenViewForm(rowData)}
            />
          );
        },
        maxWidth: 100,
        minWidth: 100,
        sortable: false,
        filter: false,
        pinned: 'left',
      },
    ];
  }, [handleClickOpenEditForm, handleClickDelete]);

  const columnDefs = useMemo(() => {
    return [
      ...actionsColumn,
      {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Owner',
        field: 'priceSheetOwner',
        flex: 1,
        filter: 'agSetColumnFilter',
        filterParams: filterParams(owner?.map((item) => item.display_name)),
      },
      {
        headerName: 'Pricing Model',
        field: 'priceModel',
        flex: 1,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        flex: 2,
        filter: 'agTextColumnFilter',
        valueFormatter: DateFormatter,
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'End Date',
        field: 'endDate',
        flex: 2,
        filter: 'agTextColumnFilter',
        valueFormatter: DateFormatter,
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Currency',
        field: 'currencyPrice',
        flex: 2,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Discount Percent',
        field: 'discountPercent',
        flex: 2,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      {
        headerName: 'Discount Amount',
        field: 'discountAmount',
        flex: 2,
        filter: 'agTextColumnFilter',
        filterParams: commonTextFilterParams,
      },
      // {
      //   headerName: 'Status',
      //   field: 'status',
      //   flex: 2,
      //   filter: 'agTextColumnFilter',
      //   filterParams: commonTextFilterParams,
      // },
      {
        headerName: 'Active',
        field: 'productActive',
        flex: 1,
        cellRenderer: (p) => (p.value ? 'Yes' : 'No'),
      },
    ];
  }, [actionsColumn, commonTextFilterParams, filterParams, priceSheetList, gridData, owner]);

  return columnDefs;
};

export default usePriceColumnDefs;
